import React from 'react';
import { View, Text, StyleSheet,Dimensions, Image,ImageBackground, TouchableWithoutFeedback, StatusBar } from 'react-native';
// import {Toast} from 'native-base';
import moment from 'moment';
import PaymentStrip from './paymentStrip';
import {
    isFixedTest,
    isAnyTimeTest,
    isTimePeriodTest,
    _isUserAttempted,
    _isUserUnAttempted,
    _isUserSubmitted,
    isTestInAnHour,
    isTimeEndForTestStart,
    isTestSeriesFree,
    isTestSeriesTestFree,
    isTestSeriesUserPaid,
    isPercentageArrayLengthZero,
} from './testSeriesValidations';
import { FOR_TEST_SERIES } from "./../store/constants";
import Lock from '@material-ui/icons/Lock';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import Timer from './../timer'

const { width, height } = Dimensions.get('window');
const bgImage = require('./../assets/assets_png/file_ex.png');
const star = require('../assets/assets_png/star1.png');
const clock = require('../assets/assets_png/clock.png');
const play = require('../assets/assets_png/play.png');
// import Icon from 'react-native-vector-icons/Ionicons';
// import { HeaderBackButton } from './../components';



 
const DateComponent = ({startDate, endDate}) => {
    // const isValidStartDate = moment(startDate).isValid();
    // const isValidEndDate = moment(endDate).isValid();

    return(
        <>
         <Image source={clock} style={{ width: 28, height: 28}}/>
         {/* <Icon name='ios-time' color='rgba(255,255,255, 0.65)' size={28} /> */}
                <View style={styles.dateWrapper}>
                    <View style={styles.flexRow}>
                        <Text style={styles.dayText}>
                            {
                                moment(startDate).format('ddd')
                            }
                            {', '}
                        </Text>
                        <Text style={[styles.dayText]}>
                            {moment(startDate).format('MMMM D')}
                        </Text>
                    </View>
                    <Text style={styles.timeText}>
                        {
                            moment(startDate).format('LT')
                        }
                    </Text>
                </View>
                <View style={styles.flexRow}>
                    <Text style={{color: '#fff', fontSize: 20, fontWeight: '700'}}> - </Text>
                </View>
                <View style={styles.dateWrapper}>
                    <View style={styles.flexRow}>
                        <Text style={styles.dayText}>
                        {
                                moment(endDate).format('ddd')
                            }
                            {', '}
                        </Text>
                        <Text style={[styles.dayText]}>
                            {moment(startDate).format('MMMM D')}
                        </Text>
                    </View>
                    <Text style={styles.timeText}>
                        {
                            moment(startDate).format('LT')
                        }
                    </Text>
                </View>
        </>
    )
}

const showToaster = (msg) => {
    // Toast.show({
    //     text: msg
    // })
}

const TestSeriesTestDetailsButton = ({
    isUserAccessible,
    canUserStart,
    isTestCompleted,
    testSeriesTestId,
    goToScreen,
    isTestStarted,
    showToaster
}) => {
    
    return (
        <TouchableWithoutFeedback
        onPress={() => {
            if (!isUserAccessible) return  showToaster('Please purchase the test', 1000);
            if (canUserStart) return goToScreen('/TestTerms', testSeriesTestId);
            if (isTestCompleted) return goToScreen('/ShowResults', testSeriesTestId);
            if(isUserAccessible && !canUserStart ) return showToaster('Wait for the test start time', 1000)              
        }}
        > 
        {
            isTestCompleted
            ?
            (
                <View style={[styles.buyNow, ]}>
                <Text style={{fontSize: 20, fontWeight: '700', 
                color: '#fff', }}> {'Result'  }</Text>
                  {
                    isUserAccessible
                    ?
                    null
                    : 
                    
                     <Lock
                        style={{
                        marginLeft: 10,
                        color: '#fff',
                        width: 24,
                        height: 24
                        }}
                    />
                              
                }
                </View>     
              
            )
            :
                <View style={[styles.buyNow, ]}>
                <Text style={{fontSize: 20, fontWeight: '700', 
                color: '#fff', }}> { 'Start Test' }</Text>
                   {
                    isUserAccessible
                    ? 
                     null
                    // <KeyboardArrowRightIcon
                    // style={{
                        
                    //     color: '#fff',
                    //     width: 20,
                    //     height: 20,
                    //     marginLeft: 10,
                        
                    //     }}
                    // />
                    : 
                    
                    <Lock
                    style={{
                        
                        marginLeft: 10,
                        color: '#fff',
                        width: 20,
                        height: 20,
                        
                        
                        }}
                    />
                        
                }
                </View> 

        }
            {/* <View style={[styles.buyNow, ]}>
            <Text style={{fontSize: 20, fontWeight: '700', 
            color: '#fff', }}> { isTestCompleted ? 'Result' : 'Start Test' }</Text>
            </View>  */}
        </TouchableWithoutFeedback>
    )
}

const TestSeriesDetailsComponent = ({
    seriesDetails, 
    isTestList, explanation, 
    isTestCompleted,
    canUserAttempt,
    userTestStatus,
    navigation,
    paymentId,
    _price,
    makePayment,showToaster
}) => {
 
    const {
        title,
        mock_series_code,
        actual_price,
        discount_price,
        is_discount,
        exam_code,
        is_daily_test,
        sortorder, 
        is_free,
        mock_tests =[],
        mock_series_payment=[],
        image_url,
        id,
        description,
     //    exam_code,
        exam_name,
        end_date_time,
        start_date_time,

    } = seriesDetails || {};
   
    const {status=null} =  mock_series_payment && mock_series_payment[0] || {};
    let price = (is_free)  ? 'Free' : is_discount ? '₹' + discount_price + '.00' : ' ';
    const actualPrice = actual_price < 1 ?  'Free' : '₹' + actual_price + '.00';

    let isFree = actual_price < 1 || is_free;
    // if(is_free){
    //    isFree = actual_price < 1 || is_free;
    // }
    // console.log(actual_price < 1 || is_free , "Asd")
    const priceForBuy = is_discount ? discount_price : actual_price;
    console.log(priceForBuy, "Sad")
    const goToScreen = (screen, testSeriesTestId) => {
        navigation.push(screen, {
            testId: id,
            isTestSeries: true
        })
    }
    

    return(
        <View
        style={styles.detailsComponent}
        >
        <ImageBackground 
            source={{uri: image_url}}
            style={{
                width: '100%', 
                height: '100%' ,
                position: 'relative',
            
            }}
            // imageStyle={{  
            //     borderTopLeftRadius: 30,
            //     borderTopRightRadius: 30,
                
            // }}
            
        >
            <View style={{flex: 1, position: 'relative', zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.65)'}}>
            <View style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // marginTop: 22
            }}>
            
            <View />
              <View style={{flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingVertical: 8, paddingTop: 12, paddingLeft: 10}}>
                  <View>
                    {/* <HeaderBackButton position style={{height: 30, width: 30, borderWidth: 2}} secondary />
                    <StatusBar barStyle='light-content' backgroundColor='rgba(0,0,0,0)' /> */}
                  </View>
                    {
                    isFree ? <View />
                    :
                    !priceForBuy ?
                     <View/>
                     : 
                    <PaymentStrip 
                    price={priceForBuy}
                    discount={is_discount}
                    actualPrice={actual_price}
                    />   
                }
                </View>
             
            </View>
            <View style={styles.topicDetails}>
               <Text style={[styles.examTitle, {marginBottom: 8}]}> 
                {exam_name}
               </Text>
               <Text style={styles.topicTitle}
                ellipsizeMode="tail" numberOfLines={2}
               > 
                    {title}
                </Text>
            </View>
            <View style={styles.dividerLine}/>  
            <View style={[styles.dateBox, {marginTop: 12, paddingBottom: 12}]}>
               <DateComponent  startDate={start_date_time} endDate={end_date_time} />
            </View>
            <View style={styles.bottomComponent}>
                {
                    explanation ?
                    <>
                        <View style={{flexDirection: 'row', alignItems: 'center', marginHorizontal: 10, }}>
                            <Image source={play} style={{width: 32, height: 32}}/>

                            <View style={{flexDirection:'column', justifyContent: 'flex-start', textAlign: 'justify', marginHorizontal: 10 }}>
                            <Text style={{color: '#fff', fontSize: 18,}}>Watch</Text>
                                <Text style={{color: '#fff', }}>Explanatory Video</Text>
                            </View>
                        </View>
                        <TestSeriesTestDetailsButton
                            isUserAccessible = { isTestSeriesFree(_price) || isTestSeriesTestFree(is_free) || isTestSeriesUserPaid(paymentId) }
                            canUserStart = { (isTestSeriesFree(_price) || (is_free || paymentId)) && !_isUserSubmitted(userTestStatus)  && !isTestCompleted && canUserAttempt }
                            isTestCompleted = { _isUserSubmitted(userTestStatus) || isTestCompleted }
                            goToScreen={goToScreen}
                            isTestStarted={(moment(start_date_time) - moment()) / 1000 < 0}
                            showToaster={showToaster}

                        />
                    
                    </>
                    :
                    <>
                    <View style={{flexDirection: 'row', alignItems: 'center', }}>
                        <View style={styles.duration}>
                        <Text style={{fontWeight: '500', color: '#fff', fontSize: 13, paddingHorizontal: 3}}>8 Tests</Text>
                        </View>
    
                        <View style={[styles.duration, {flexDirection:'row', alignItems: 'center'}]}>
                        {/* <Image source={star} style={{width: 12, height: 12,}}/> */}
                            {/* <Icon name='md-information-circle' color='#fff' /> */}
                            <Text style={{color: '#fff', marginLeft: 4, fontSize: 13, fontWeight: '500'}}>Know More</Text>
                        </View>
                    </View>
                    <TouchableWithoutFeedback
                        onPress={() => {
                            if(isFree) return;
                            if(typeof makePayment === 'function') makePayment(FOR_TEST_SERIES, id, priceForBuy);
                        }}
                    >
                        <View style={[styles.buyNow, {height: 50, } ]}>
                        <Text style={{fontSize: 16, fontWeight: '700', textTransform: 'uppercase', 
                        color: '#fff', }}> { isFree ? 'Free' : 'Buy now' }</Text>
                        </View>
                    </TouchableWithoutFeedback>
                    </>
                }
                
            </View>
            </View>
            <View 
                style={{
                    ...StyleSheet.absoluteFill,
                    backgroundColor: 'rgba(0,0,0,0.70)',
                    zIndex: 1
                }}
            />
        </ImageBackground>
      
        </View>
    )
}

export default TestSeriesDetailsComponent;

const styles = StyleSheet.create({
    detailsComponent: {
        width: '100%',
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        height: 350,
        flexDirection: 'column',
        marginBottom: 20,
        position: 'relative',
        zIndex: 100,
        // top: -5
    },
    topicDetails: {
      flex: 1,
      marginHorizontal: 10,
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      marginBottom: 8,      
    },
    examTitle: {
        fontSize: 23,
        fontWeight: '700',
        color: '#eddd00',
        textTransform: 'uppercase'
    },
    topicTitle: {
        fontSize: 18,
        fontWeight: '700',
        color: '#fff',
        textTransform: 'uppercase'
    },
    bottomComponent: {
        justifyContent: 'space-between',
        flexDirection: 'row',
       
       
    },
    duration: {
       borderWidth: 1,
       borderColor: '#fff',
       borderRadius: 10,
       height: 22,
       paddingHorizontal: 12,
       paddingVertical: 8,
       marginHorizontal: 2,
       alignItems: 'center',
       justifyContent :'center',
       marginHorizontal: 10,
    },
    buyNow: {    
        // paddingHorizontal: 30,
        width: '35%',
        height: 45,
        backgroundColor: '#249a00',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopStartRadius: 40,
        marginTop: 5 
    },
    dividerLine: {
        borderWidth: 0.5,
        borderColor: 'rgba(255,255,255,0.55)',
        marginBottom: 5,
        marginHorizontal: 10
        
     },
     dateWrapper: {
        flexDirection:'column',
        justifyContent:'center',
        alignItems: 'flex-start', 
        marginHorizontal: 10      
    },
    flexRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayText: {
        color: '#fff',
        fontSize: 14,
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    timeText: {
        color: '#fff',
        fontSize: 15,
        // fontWeight: '500',
    },
    dateBox:{
        // width:wp(95),
        // height:hp(5),
        flexDirection:'row',
        justifyContent: 'space-between',
        alignItems:'center',
        width: (width / 2 + 50),
        // paddingHorizontal: 12,
        marginLeft: 12,
        paddingBottom: 3,
        borderBottomWidth: 0.5,
        borderColor: 'rgba(255,255,255,0.55)',
         marginBottom: 5
        // backgroundColor: 'red'
      },
   
})